import React, { FC } from 'react';
import { TextInput, View } from 'react-native';

import { COLORS } from '../../../config/designSystem/Colors';
import { Caption1Bold, Title3, mainTypoRegular } from '../../../config/designSystem/typography';
import { InfoCard } from '../ui/InfoCard';
import { QuestionSessionBodyPresentationProps } from '../../QuestionSessions/QuestionSessionBody/config';
import { SPACING } from '../../../config/designSystem/Spacing';
import { SelectField } from '../ui/SelectField';
import { SleepDetailsData } from './ContainSleepDetails';
import { StepperField } from '../ui/StepperField';
import { useDiaryMaxWidth } from '../ui/useDiaryMaxWidth';

/**
 * figma: SleepDiary "Let's get the details of your night" (Activities & Challenges pt1)
 * Bedtime and wake-up time pickers, time to fall asleep, awakenings stepper,
 * optional notes and the helper card.
 */
export const PresentSleepDetails: FC<QuestionSessionBodyPresentationProps> = ({
  questionText,
  data,
}) => {
  const maxWidth = useDiaryMaxWidth();
  const details = (data || {}) as SleepDetailsData;

  if (!details.labels) {
    return null;
  }

  return (
    <View style={{ alignItems: 'center', paddingHorizontal: SPACING['sp-16'] }}>
      <View style={{ width: '100%', maxWidth, rowGap: SPACING['sp-24'] }}>
        <View style={{ rowGap: SPACING['sp-16'], alignItems: 'center' }}>
          <Title3 align={true}>{questionText}</Title3>
          <View
            style={{
              width: 90,
              height: 3,
              borderRadius: 2,
              backgroundColor: COLORS.content.accent,
            }}
          />
        </View>
        <View style={{ flexDirection: 'row', columnGap: SPACING['sp-16'] }}>
          <SelectField
            label={details.labels.bedtime}
            value={details.bedtime}
            options={details.bedtimeOptions}
            onChange={details.onChangeBedtime}
          />
          <SelectField
            label={details.labels.timeToFallAsleep}
            value={details.timeToSleep}
            options={details.timeToSleepOptions}
            onChange={details.onChangeTimeToSleep}
          />
        </View>
        <View style={{ flexDirection: 'row', columnGap: SPACING['sp-16'] }}>
          <SelectField
            label={details.labels.wakeUpTime}
            value={details.wakeUp}
            options={details.wakeUpOptions}
            onChange={details.onChangeWakeUp}
          />
          <StepperField
            label={details.labels.nighttimeAwakenings}
            value={details.awakenings}
            onChange={details.onChangeAwakenings}
          />
        </View>
        <View style={{ rowGap: SPACING['sp-8'] }}>
          <Caption1Bold color={COLORS.content.primary}>
            {details.labels.extraDetails}
          </Caption1Bold>
          <TextInput
            value={details.notes}
            onChangeText={details.onChangeNotes}
            multiline={true}
            style={{
              minHeight: 120,
              backgroundColor: COLORS.surface.contrast,
              borderRadius: SPACING['sp-12'],
              borderWidth: 1,
              borderColor: COLORS.border.secondary,
              padding: SPACING['sp-16'],
              fontFamily: mainTypoRegular,
              fontSize: 16,
              color: COLORS.content.primary,
              textAlignVertical: 'top',
            }}
          />
        </View>
        <InfoCard title={details.labels.infoTitle} body={details.labels.infoBody} />
      </View>
    </View>
  );
};
